var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title is-4"},[_vm._v(_vm._s(_vm.$t('Components.Reservation.ReservationCheckIns.Main_Title')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }